const getVisibleColumns = (visibleColumns, columns) => {
  if (visibleColumns) {
    return visibleColumns;
  }
  return columns.map(column => column.label);
};

export default getVisibleColumns;
